import { createStyles, makeStyles } from '@material-ui/core';
import { MAILTO } from 'next-seo.config';
import { useLinkDrawerLink } from './LegalProvider';

export const TEXT_ID_BASE = 'text-head-';

const useStyle = makeStyles((theme) =>
    createStyles({
        link: {
            color: theme.palette.primary.light
        },
        mailLink: {
            color: theme.palette.primary.light,
            cursor: 'pointer'
        },
        inPageUrl: {
            color: theme.palette.secondary.dark,
            cursor: 'pointer'
        }
    })
);

export const LinkText = (props: any) => {
    const classes = useStyle();
    return <a {...props} className={classes.link} />;
};

export const LinkTypography = (props: any) => {
    const classes = useStyle();
    return <a {...props} className={classes.link} />;
};

export const FindLinkById = (props: any) => {
    const classes = useStyle();
    const onLinkedContentClicked = useLinkDrawerLink();
    const onClick = () => {
        onLinkedContentClicked(props.children);
        // const idx = (t(
        //     'tableOfContents',
        //     {},
        //     { returnObjects: true }
        // ) as any).findIndex((el: string) => el.includes(props.children));

        // if (idx !== -1 && scrollRef) {
        //     router.push(`#${TEXT_ID_BASE}${idx + 1}`);
        //     // const el = scrollRef.querySelector(`#${TEXT_ID_BASE}${idx + 1}`);
        //     // el?.scrollIntoView({
        //     //     behavior: 'smooth'
        //     // });
        // }
    };
    return <span {...props} className={classes.inPageUrl} onClick={onClick} />;
};

export const EmailComponent = (props: any) => {
    const classes = useStyle();
    const onClick = () => {};
    return (
        <a href={MAILTO}>
            <span {...props} className={classes.mailLink} onClick={onClick} />
        </a>
    );
};
